/* get timezoneOffset in ±HH:mm format*/

export const getTimeZoneOffset = function(timezoneOffset:number) {
    const timezoneOffsetString = (timezoneOffset >= 0 ? '+' : '-') +
    (Math.floor(Math.abs(timezoneOffset))).toString().padStart(2, '0') +
    ':' +
    ((Math.abs(timezoneOffset) % 1)*60).toString().padStart(2, '0');
    return timezoneOffsetString
  }
